import Button from 'antd/es/button';
import Menu from 'antd/es/menu';
import Typography from 'antd/es/typography';
import styled from 'styled-components';

export const StyledMenu: typeof Menu = styled(Menu)`
  .ant-menu-item-selected {
    background-color: ${({ theme }) => theme.token.colorPrimary} !important;
    color: white !important;
  }
  .ant-menu-item:hover {
    color: white !important;
  }

  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    background-color: ${({ theme }) => theme.token.colorPrimary} !important;
    color: ${({ theme }) => theme.token.colorPrimaryText} !important;
  }

  .ant-menu-item-group-title {
    padding-right: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .ant-menu-sub.ant-menu-inline {
    background: none !important;
  }

  .ant-tree-list-holder-inner {
    max-height: 10rem;
    overflow-y: auto;
    scrollbar-gutter: stable;

    & > *:first-child {
      position: sticky;
      top: 0;
      z-index: 1;
      background-color: ${({ theme }) => theme.token.colorBgElevated};
    }
  }
`;

export const MenuContainer = styled.div<{ $collapsed: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: ${({ $collapsed }) => ($collapsed ? '3rem' : '100%')};
  gap: 0.5rem;
`;

export const MenuContent = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow-y: auto;
  justify-content: space-between;
`;

export const StyledButton = styled(Button)`
  padding: 0;
  height: 20px;
  width: 20px;
  min-width: 20px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.token.colorTextSecondary};

  .ant-tree-node-selected & {
    color: ${({ theme }) => theme.token.colorTextLightSolid};
  }

  &:hover {
    background: transparent;
    color: ${({ theme }) => theme.token.colorPrimary};
  }

  /* Force color inheritance through the entire icon chain */
  .ant-btn-icon,
  .anticon,
  span {
    color: inherit !important;
  }

  /* Override any other styles that might affect the SVG */
  .ant-tree-node-selected & .anticon svg {
    fill: ${({ theme }) => theme.token.colorTextLightSolid} !important;
  }

  &:hover .anticon svg {
    fill: ${({ theme }) => theme.token.colorPrimary} !important;
  }
`;

export const EmptyFolderText = styled(Typography.Text)`
  font-style: italic;
  padding-left: 8px;
`;
